import { DatePicker } from "@watt/ui/components/ui/date-picker";
import {
  FormControl,
  FormItem,
  FormMessage
} from "@watt/ui/components/ui/form";
import AutoFormLabel from "../common/label";
import AutoFormTooltip from "../common/tooltip";
import type { AutoFormInputComponentProps } from "../utils/types";

export default function AutoFormDate({
  label,
  isRequired,
  field,
  fieldConfigItem,
  fieldProps
}: AutoFormInputComponentProps) {
  return (
    <FormItem>
      <AutoFormLabel
        isRequired={isRequired}
        label={fieldConfigItem?.label || label}
      />
      <FormControl>
        <DatePicker
          date={field.value}
          setDate={field.onChange}
          {...fieldProps}
        />
      </FormControl>
      <AutoFormTooltip fieldConfigItem={fieldConfigItem} />

      <FormMessage />
    </FormItem>
  );
}
